<template>
	<div>
		<van-nav-bar class="userNavBar" @click-left="onClickLeft" title="实名认证" left-arrow>
			<template #left>
				<van-icon name="../../../static/images/mobile/back.png" size="18" />
			</template>
		</van-nav-bar>
		<div class="realNamePic">
			<img src="../../../static/images/mobile/authentication.png" alt="" />
			<div class="realNameMessage">已认证</div>
		</div>
		<div class="realName">
			<van-cell class="realNames" title="姓名" :value="realName" />
			<van-cell class="idcard" title="身份证号" :value="idcard" />
		</div>
		<van-tabbar v-model="active">
			<van-tabbar-item to="/mobileHome">
				<span>首页</span>
				<template #icon="props">
					<img :src="props.active ? index.active : index.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileStudy">
				<span>班级</span>
				<template #icon="props">
					<img :src="props.active ? classes.active : classes.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileMy">
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ? my.active : my.inactive" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
export default {
	data() {
		return {
			active: 2,
			index: {
				active: "../../../static/images/mobile/onIndex.png",
				inactive: "../../../static/images/mobile/index.png",
			},
			classes: {
				active: "../../../static/images/mobile/onClass.png",
				inactive: "../../../static/images/mobile/class.png",
			},
			my: {
				active: "../../../static/images/mobile/onMy.png",
				inactive: "../../../static/images/mobile/my.png",
			}, //table栏
			idcard: "",
			realName: "",
		};
	},
	methods: {
		onClickLeft() {
			this.$router.go(-1);
		},
		getUserInfor() {
			this.$api.get("/user/getUserDetail", null, (res) => {
				if (status == 0) {
					this.realName = res.data.realName;
					this.idcard = res.data.idcard;
				}
			});
		},
	},
	created() {
		this.getUserInfor();
	},
	beforeCreate() {
		document.querySelector("body").setAttribute("style", "background:#eee");
	}, //
	beforeDestroy() {
		document.querySelector("body").removeAttribute("style");
	},
};
</script>

<style scoped>
.body {
	background-color: #f2f2f2;
}
.realNamePic img {
	width: 2.346667rem;
	height: 2.346667rem;
	margin: 0 auto;
	margin-top: 0.853333rem;
	margin-bottom: 0.213333rem;
}
.realNameMessage {
	color: #707070;
	font-size: 0.373333rem;
	font-weight: 400;
	margin: 0 auto;
	margin-bottom: 0.986667rem;
}
.realNamePic {
	display: flex;
	flex-direction: column;
}
.van-cell-group {
	width: 9.146667rem;
	margin: 0 auto;
	margin-bottom: 2rem;
}
.realNames {
	border-radius: 0.106667rem 0.106667rem 0 0;
}
.idcard {
	border-radius: 0 0 0.106667rem 0.106667rem;
}
.realName {
	padding-left: 0.426667rem;
	padding-right: 0.426667rem;
}
</style>


// WEBPACK FOOTER //
// MobileAuthentication.vue?614c1985